export enum PaymentStatus {
    SUCCEEDED = 'SUCCEEDED',
    REQUIRES_PAYMENT_METHOD = 'REQUIRES_PAYMENT_METHOD',
    REQUIRES_CONFIRMATION =  'REQUIRES_CONFIRMATION',
    REQUIRES_ACTION = 'REQUIRES_ACTION',
    PROCESSING = 'PROCESSING',
    CANCELED = 'CANCELED',
    REJECTED = 'REJECTED',
    REFUNDED = 'REFUNDED',
    PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED'
}



// WEBPACK FOOTER //
// ./src/app/models/payment/payment-status.enum.ts